namespace Portico.Models.Enterprise {

    import ent = Portico.Models.Enterprise;

    export interface IEnrollment {
		id: number;
		caseId: number;
        startDate: Date;
        endDate: Date;
        claimEligibilityDate: Date;
		reEnrollmentEligibilityDate: Date;
		status: EnrollmentEligibility;
		householdSize: number;
        isOptedIn: boolean;
        maxBenefit: string;
        memberNumber: string;
		paymentType: string;
		createdBy: number;
		createdOn: Date;
		updatedBy: number;
		updatedOn: Date;
    }

    export class Enrollment implements IEnrollment {
		id: number;
		caseId: number;
		startDate: Date;
		endDate: Date;
		claimEligibilityDate: Date;
		reEnrollmentEligibilityDate: Date;
		status: EnrollmentEligibility;
		householdSize: number;
		isOptedIn: boolean;
		maxBenefit: string;
		memberNumber: string;
		paymentType: string;
		createdBy: number;
		createdOn: Date;
		updatedBy: number;
		updatedOn: Date;

        constructor(obj?: IEnrollment) {
            this.id = null;
			this.caseId = null;
            this.startDate = null;
            this.endDate = null;
            this.claimEligibilityDate = null;
			this.reEnrollmentEligibilityDate = null;
			this.status = null;
			this.householdSize = null;
            this.isOptedIn = null;
            this.maxBenefit = null;
            this.memberNumber = null;
            this.paymentType = null;
			this.createdBy = null;
			this.createdOn = null;
			this.updatedBy = null;
			this.updatedOn = null;

            if (obj) {
                this.id = obj.id;
				this.caseId = obj.caseId;
                this.startDate = obj.startDate;
                this.endDate = obj.endDate;
                this.claimEligibilityDate = obj.claimEligibilityDate;
				this.reEnrollmentEligibilityDate = obj.reEnrollmentEligibilityDate;
				this.status = obj.status;
				this.householdSize = obj.householdSize;
                this.isOptedIn = obj.isOptedIn;
                this.maxBenefit = obj.maxBenefit;
                this.memberNumber = obj.memberNumber;
                this.paymentType = obj.paymentType;
				this.createdBy = obj.createdBy;
				this.createdOn = obj.createdOn;
				this.updatedBy = obj.updatedBy;
				this.updatedOn = obj.updatedOn;
			}
        }
    }
}
